import { useQuery } from "@tanstack/react-query";
import { Activity, LayoutDashboard, Repeat } from "lucide-mui";
import { Outlet } from "react-router-dom";
import { api } from "../../api/client.ts";
import { keys } from "../../api/queryKeys.ts";
import NavTabs, { type NavTab } from "../../components/NavTabs.tsx";
import PageHeader from "../../components/PageHeader.tsx";
import { formatNumber } from "../../utils/format.ts";

const TABS: NavTab[] = [
  { label: "Overview", to: "/platform", icon: <LayoutDashboard /> },
  { label: "Signals", to: "/platform/signals", icon: <Activity /> },
  { label: "Recurring", to: "/platform/recurring", icon: <Repeat /> },
];

/**
 * Platform health: one header, a tab per part of the platform. The overview
 * (imports, company coverage, local inference, infrastructure), the signal
 * engine (the inbox per data type, every tenant's signal workflows) and
 * recurring work (periodic Restate jobs and durable tasks).
 * Site-wide staff only (`platform:read`).
 */
export default function PlatformLayout() {
  // Both tabs read these; the header shares the cache.
  const stats = useQuery({
    queryKey: keys.masterCompany.stats(),
    queryFn: api.getMasterCompanyStats,
    meta: { live: true },
  });
  const health = useQuery({
    queryKey: keys.platform.health(),
    queryFn: api.getPlatformHealth,
    meta: { live: true },
  });
  const description =
    health.data && stats.data
      ? `${formatNumber(health.data.sources.length)} imports · ${formatNumber(stats.data.total_companies)} companies`
      : "Master companies, website coverage, the enrichment pipeline and the signal engine";

  return (
    <>
      <PageHeader
        title="Platform health"
        description={description}
      />
      <NavTabs tabs={TABS} label="Platform sections" />
      <Outlet />
    </>
  );
}
